var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleWarning = function SvgTriangleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.709 15.274 12.28 1.354a2.587 2.587 0 0 0-4.552 0L.3 15.275a2.532 2.532 0 0 0 1.075 3.437c.375.19.784.297 1.209.297h14.848c1.417 0 2.567-1.131 2.576-2.536 0-.413-.1-.826-.3-1.198Z",
    fill: "#C11A46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H9v-2h2v2Zm0-4H9V5h2v7Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v19H0z"
  })))));
};
export default SvgTriangleWarning;